module.exports = __webpack_public_path__ + "img/img(1).0794e1f0.jpg";